$(document).ready(function (params) {
  let designRequest;
  let designRequestId = 0;
  let designDeadline;

  document.addEventListener('variant:change', function (event) {
    const detail = event.detail || {};
    const form = detail.formId && document.getElementById(detail.formId);
    const variant = detail.variant;
    const idInput = form && form.elements && form.elements.namedItem('id');
    if (!variant || !idInput || String(idInput.value) !== String(variant.id || '')) return;

    document.querySelectorAll('[data-gemstone-sku][form]').forEach(function (input) {
      if (input.getAttribute('form') === form.getAttribute('id')) input.value = typeof variant.sku === 'string' ? variant.sku : '';
    });
  });

  // Keep the existing click path as the single source of cart-field updates.
  $(document).on('keydown', '#wear-options .design-item, #metal-options .design-item, .design-options .design-item, #change-design', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    if (!event.repeat) this.click();
  });

  function escapeMarkup(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function designMessage(key) {
    return $('#design-options').attr(`data-${key}`) || '';
  }

  function isGoldMetal(metal) {
    return metal === '18k Gold' || metal === '22k Gold';
  }

  // Amounts are formatted by Shopify for the design's native presentment price.
  // Never infer a deposit from the gemstone price or substitute a fixed amount.
  function advanceMessage(key, item) {
    const amount = item.getAttribute('data-setting-amount');
    const template = designMessage(key);
    if (item.getAttribute('data-setting-advance') !== 'true' || typeof amount !== 'string' ||
        !amount.trim() || amount.length > 120 || /[<>\u0000-\u001f\u007f]/.test(amount) ||
        !/\p{N}/u.test(amount) || !template.includes('[amount]')) return '';
    return escapeMarkup(template).split('[amount]').join(escapeMarkup(amount.trim()));
  }

  function clearDesignSelection() {
    $('#design-input, #design-prod').val('');
    $('.design-options .design-item').removeClass('selected').attr('aria-pressed', 'false');
    $('.design-options .design-container').removeClass('hide');
    $('#selected-design').removeClass('active');
    $('.selected-design-content').html('');
  }

  function showDesignStatus(key) {
    $('#design-options').html(`<p class="option-label" role="status">${escapeMarkup(designMessage(key))}</p>`);
  }

  $(document).on('click', '#wear-options .design-item', function () {
    const $this = $(this);
    const value = $this.data('value');

    $('#wear-options .design-item').removeClass('selected').attr('aria-pressed', 'false');
    $this.addClass('selected').attr('aria-pressed', 'true');
    $('#wear-value').text($this.find('.sr-only').text());

    const isLooseGem = value === 'loose-gemstone';
    $('#design-options, #metal-options').toggle(!isLooseGem);
    $('#metal-input').val(isLooseGem ? '' : $('#metal-options .design-item.selected').attr('data-value'));

    const fields = {
      '#design-prod': 'items[1][id]',
      '#design-qty': 'items[1][quantity]',
      '#design-gemstone': 'items[1][properties][Gemstone]',
      '#design-gem-sku': 'items[1][properties][Gemstone SKU]'
    };

    $.each(fields, (selector, name) => {
      isLooseGem ? $(selector).removeAttr('name') : $(selector).attr('name', name);
    });

    if(!isLooseGem) {
      let noticeShown = false;
      try { noticeShown = sessionStorage.getItem("goldNoticeShown") === 'true'; } catch (_) {}
      if (!noticeShown) {
        $("#gold-warning-popup").css("display", "flex");
        try { sessionStorage.setItem("goldNoticeShown", "true"); } catch (_) {}
      }
    }

    $('#ring-size-selector').toggle(value === 'ring');
    $('#ring-size-system').prop('required', value === 'ring');

    updateDesigns($('#metal-options .design-item.selected').data('value'), value);
  });

  $(".gold-close").on("click", function () {
    $("#gold-warning-popup").hide();
  });

  $(".gold-close, .gold-ok-btn").on("click", function () {
    $("#gold-warning-popup").hide();
  });

  $(window).on("click", function (e) {
    if ($(e.target).is("#gold-warning-popup")) {
      $("#gold-warning-popup").hide();
    }
  });

  $(document).on('click', '#metal-options .design-item', function () {
    $('#metal-options .design-item').removeClass('selected').attr('aria-pressed', 'false');
    $(this).addClass('selected').attr('aria-pressed', 'true');

    const value = $(this).attr('data-value');
    $('#metal-input').val(value);

    const wear = $('#wear-options .design-item.selected').attr('data-value');
    updateDesigns(value, wear);
  });

  $(document).on('click', '.design-options .design-item', function () {
    if ($(this).attr('aria-disabled') === 'true') return;
    $('.design-options .design-item').removeClass('selected').attr('aria-pressed', 'false');
    $(this).addClass('selected').attr('aria-pressed', 'true');

    const value = $(this).attr('data-value');
    const variantId = $(this).attr('data-var-id');
    $('#design-input').val(value);
    $('#design-prod').val(variantId);

    $('.design-options .design-container').addClass('hide');
    $('#selected-design').addClass('active');

    /*const optionText = $(this).find('p').text();
    var imgURL = $(this).find('.design-item-image').attr('style')
    imgURL = imgURL.replace('--swatch-background: url(', 'https://').replace(')', '');
    $('.selected-design-content').html(`You Have Selected <span id="selected-option">${optionText}</span> Click <span id="change-design">HERE</span> to change your preference. You can opt to have your gemstone in a Ring or a Necklace`);
    $('.selected-design-image img').attr('src', imgURL);*/

    const optionText = escapeMarkup($(this).attr('data-value'));
    const changeLabel = escapeMarkup($('#design-options').attr('data-change-design-label'));
    const changeControl = `<span id="change-design" role="button" tabindex="0" aria-label="${changeLabel}">${changeLabel}</span>`;
    const selectedMetal = $('#metal-options .design-item.selected').attr('data-value');
    const selectedText = escapeMarkup(designMessage('selected-design')).replace('[design]', `<span id="selected-option">${optionText}</span>`);
    const advanceNotice = isGoldMetal(selectedMetal) ? advanceMessage('advance-notice', this) : '';
    const advance = advanceNotice ? ` ${advanceNotice}` : '';
    $('.selected-design-content').html(`${selectedText}${advance} ${changeControl}. ${escapeMarkup(designMessage('wear-notice'))}`);
    $('#change-design')[0]?.focus();
  });

  $(document).on('click', '#change-design', function () {
    clearDesignSelection();
    $('#design-options .design-item')[0]?.focus();
  });

  function updateDesigns(metal, wear) {
    const requestId = ++designRequestId;
    window.clearTimeout(designDeadline);
    if (designRequest && typeof designRequest.abort === 'function') designRequest.abort();
    designRequest = null;
    clearDesignSelection();
    const $designOptions = $('#design-options');
    const gemName = $designOptions.attr('data-gem_name');
    const ringOptions = ($designOptions.attr('data-ring_options') || '').split(',').map(value => value.trim());
    const pandentOptions = ($designOptions.attr('data-pandent_options') || '').split(',').map(value => value.trim());

    if (wear === 'loose-gemstone') return;

    if (typeof metal !== 'string' || !['ring', 'pendant'].includes(wear)) return;
    metal = metal.toLowerCase();
    if (metal.includes('gold')) {
      metal = 'gold';
    }

    let productHandle = `${metal}-${wear}`;
    if (metal !== 'gold' &&  wear === 'ring') {
      productHandle = `${metal}-${wear}-1`;
    }

    showDesignStatus('loading-designs');
    let settled = false;
    const fail = () => {
      if (settled || requestId !== designRequestId) return;
      settled = true;
      window.clearTimeout(designDeadline);
      showDesignStatus('designs-unavailable');
    };
    designDeadline = window.setTimeout(() => {
      fail();
      if (designRequest && typeof designRequest.abort === 'function') designRequest.abort();
    }, 15000);
    const root = window.Shopify?.routes?.root || '/';
    designRequest = $.ajax({
      url: `${root}products/${productHandle}?view=design-options-html`,
      type: 'GET',
      timeout: 15000,
      success: function (response) {
        if (settled || requestId !== designRequestId) return;
        settled = true;
        window.clearTimeout(designDeadline);
        // Create a temporary container to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = response;

        // Get all design items
        const allDesignItems = tempDiv.querySelectorAll('.design-item');

        // Determine which options to allow based on wear
        const allowedOptions = wear === 'ring' ? ringOptions : pandentOptions;

        // // Track the first allowed item
        // let firstAllowedItem = null;

        // // Filter items based on data-value
        // allDesignItems.forEach(item => {
        //   const value = item.getAttribute('data-value');
        //   if (!allowedOptions.includes(value)) {
        //     item.remove(); // Remove unlisted items
        //   } else if (!firstAllowedItem) {
        //     firstAllowedItem = item; // Save the first allowed item
        //   }
        // });

// GET MAKING CHARGE DATA & Convert string to object
        const makingChargeData = $designOptions.attr('data-making-charge');
        const makingChargeMap = {};


        // Convert string to object
        if (makingChargeData) {
          makingChargeData.split(',').forEach(item => {
            const parts = item.split(':');
            if (parts.length >= 2) {
              const key = parts[0].trim();
              const value = parts[1].trim();
              makingChargeMap[key] = value;
            }
          });
        }


        // Track the first allowed item
        let firstAllowedItem = null;

        // Filter items based on data-value
        allDesignItems.forEach(item => {

          const value = item.getAttribute('data-value');

          if (!allowedOptions.includes(value) || item.getAttribute('aria-disabled') === 'true') {
            item.remove(); // Remove unlisted items
          } else if (!firstAllowedItem) {
            firstAllowedItem = item; // Save the first allowed item
          }

          // Find making charge
          const makingCharge = makingChargeMap[value];
          // Get selected metal
          const selectedMetal = $('#metal-options .design-item.selected').attr('data-value');
          const pTag = item.querySelector('p');

          // Add making charge after title
          // Show making charge only for ring + gold
          if ((wear === 'ring' || wear === 'pendant') && makingCharge && pTag && isGoldMetal(selectedMetal)) {
            const advanceOnly = advanceMessage('advance-only', item);
            pTag.innerHTML = `${escapeMarkup(value)}${advanceOnly ? ` (${advanceOnly})` : ''} <span class="making-charge"> + ${escapeMarkup(makingCharge)} ${escapeMarkup(designMessage('making-charge-label'))} </span>`;
          }  
        });

        // Add 'selected' class to the first allowed item, if any
        if (!firstAllowedItem) { showDesignStatus('designs-unavailable'); return; }

        // Inject filtered HTML into the DOM
        $designOptions.html(tempDiv.innerHTML);
        applyGemDesignImages($designOptions[0], gemName);
        // $('.design-options .design-item.selected').click();
      },
      error: function (xhr, status, error) {
        fail();
      }
    });
  }

  function applyGemDesignImages(root, gemName) {
    if (!root || typeof gemName !== 'string' || !/^[a-z0-9][a-z0-9_-]{0,78}_$/.test(gemName)) return;

    root.querySelectorAll('[data-design-image-template]').forEach(function (swatch) {
      const template = swatch.getAttribute('data-design-image-template');
      if (!template || !template.includes('__gm_gem__')) return;

      const imageUrl = template.replace('__gm_gem__', gemName);
      const image = new Image();
      image.onload = function () {
        swatch.style.setProperty('--swatch-background', `url("${imageUrl.replace(/"/g, '%22')}")`);
      };
      image.src = imageUrl;
    });
  }
});
